import { useSuspenseQuery } from '@tanstack/react-query';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { mapUsageDTOtoAreaChartData } from 'src/common/utils/mapUsageDTOtoAreaChartData';
import { useTranslation } from 'react-i18next';
import { rsimGraphsQueries } from '../queries/rsimGraphsQueries';
import { getRSimUsageData } from '../api/rsimGraphsApi';

type UseSimUsageDataProps = {
  accountRef: string;
  chartType: ChartTypeValue;
  usageType: UsageTypeValue;
};

type MappedUsageData = ReturnType<typeof mapUsageDTOtoAreaChartData>;

export const useRSimUsageData = ({ accountRef, chartType, usageType }: UseSimUsageDataProps) => {
  const { t } = useTranslation();
  const { data } = useSuspenseQuery<
    Awaited<ReturnType<typeof getRSimUsageData>>,
    Error,
    MappedUsageData
  >({
    queryKey: rsimGraphsQueries.usage({
      accountRef,
      chartType,
      usageType,
    }),
    queryFn: () => setMinimalPromiseTime(getRSimUsageData({ accountRef, chartType, usageType })),
    select: (data) => mapUsageDTOtoAreaChartData(data, usageType, t),
  });

  return data;
};
